import 'react-loading-skeleton/dist/skeleton.css'

import Skeleton from 'react-loading-skeleton'

import { Location } from '@/components/icons/Location'

export const PharmacyCardSkeleton = () => {
  return (
    <span className="flex w-full flex-col gap-2 rounded-[5px] border border-transparent bg-white p-3">
      <Skeleton className="h-6" />
      <div className="flex items-center gap-3">
        <Location customClassName="text-primary h-5 min-w-[13px]" />
        <div className="flex w-full flex-col">
          <Skeleton className="h-6" />
          <Skeleton className="h-6" />
        </div>
      </div>
    </span>
  )
}
